import { TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

/**
 * MUI TextFieldのラッパーコンポーネント
 * - react-hook-formのControllerと組み合わせて使用し、バリデーションエラーを自動表示する
 * - props: name (フィールド名), control (react-hook-form制御オブジェクト),
 *          rules (バリデーションルール), label (ラベル), variant (MUIバリアント)
 */
export const FormTextField = ({
  name,
  control,
  rules,
  label,
  variant,
  ...props
}: any) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          variant="outlined"
          error={fieldState.error}
          helperText={fieldState.error ? fieldState.error.message : ""}
          fullWidth
          {...props}
        />
      )}
    />
  );
};
